import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,      
  isAuthenticated: false, 
  status: 'idle',    
  error: null,  
  token: null,
  selectedYear: null // Default to current year
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.status = 'loading'; 
      state.error = null;   
    },
    loginSuccess: (state, action) => {
      state.status = 'succeeded'; 
      state.isAuthenticated = true;
      state.user = action.payload.user;  
      state.token = action.payload.token;  
    },
    loginFailure: (state, action) => {
      state.status = 'failed';    
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false; 
      state.user = null;          
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload;
    }
  },
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout,
  setSelectedYear 
} = authSlice.actions;
export default authSlice.reducer;